import { useRouter } from "@tanstack/react-router";
import { Overlay, OverlayLoading } from "@theprelude/ds";
import { Suspense } from "react";

import { ErrorBoundary } from "react-error-boundary";
import { useOverlay } from "@/hooks/use-overlay";
import { AppErrorPage } from "./app-shell/app-shell";

export function OverlayErrorFallback({ error }: { error: unknown }) {
  return <AppErrorPage error={error} />;
}

export function DefaultOverlay({
  title,
  children,
  actionsDropdown,
  defaultSize,
  onClose,
}: {
  title: string;
  children: React.ReactNode;
  actionsDropdown?: React.ReactNode;
  defaultSize?: number;
  onClose?: () => void;
}) {
  const router = useRouter();
  const overlay = useOverlay();
  return (
    <Overlay
      title={title}
      position="right"
      actionsDropdown={actionsDropdown}
      defaultSize={defaultSize}
      hideOverlay={() => {
        void overlay.close();
        onClose?.();
      }}
      onBack={() => {
        router.history.back();
        onClose?.();
      }}
    >
      <ErrorBoundary FallbackComponent={OverlayErrorFallback}>
        <Suspense fallback={<OverlayLoading />}>{children}</Suspense>
      </ErrorBoundary>
    </Overlay>
  );
}
